import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ReadMoreComponentDef } from '@df/ui/display/read-more.component.def';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';

@Component({
    selector: 'read-more',
    templateUrl: './read-more.component.html',
    styleUrl: './read-more.component.scss',
    standalone: true,
    imports: [CommonModule, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReadMoreComponent extends ReadMoreComponentDef {
    readLess = input(false);
}
